/* ==========================================================================
   CARRITO-AVISO — 2026-08-21

   Expone window.MahaAviso con tres metodos. Quien lo llama es
   assets/cart-mayoreo.js, en el camino de agregar.

     MahaAviso.mostrar({nombre, variante, foto})   aparece YA, sin cifra
     MahaAviso.piezas(n)                           rellena el hueco reservado
     MahaAviso.cancelar()                          lo retira sin dejar rastro

   REGLAS QUE CUMPLE, y por que:

   · UN SOLO AVISO. Agregar otro producto ACTUALIZA el que hay y reinicia el
     contador. Nunca se apilan: el nodo es unico, viene de
     snippets/cart-aviso.liquid y aqui solo se rellena.
   · NO ROBA EL FOCO. role="status" + aria-live="polite" ya lo anuncian a un
     lector de pantalla sin mover el foco. Aqui no hay ni un .focus().
   · NO BLOQUEA. Ni scroll ni clics: es un nodo fixed que no cubre la pagina.
   · CERO IMPORTES. Este archivo no formatea dinero ni lee ningun precio.
     Los mensajes de error viven en la pagina y no se tocan.
   · La CIFRA de piezas la pone quien llama, y sale de la RESPUESTA DEL
     SERVIDOR, nunca del campo del formulario.
   ========================================================================== */

/* ==========================================================================
   ENMIENDA 10.2, 2026-08-24 -- EL RIESGO MAS FEO: EL CANDADO DE SCROLL.

   assets/theme.css:1261-1268 convierte las clases body.modal-showing /
   body.modal-show en overflow:hidden. CartDrawer.show() (ModalComponent,
   assets/theme.js) las agrega de forma SINCRONA en cuanto se llama --
   independiente de que el panel se vea o no. La supresion visual de la
   Enmienda 9.2 (CSS de arriba) no toca esto: sin este parche, agregar un
   producto por la ruta vieja (la que corre durante la ventana de 1.4-1.8 s
   de la Enmienda 9, o desde un bundle que todavia llama a .show() directo)
   dejaria la pagina SIN SCROLL y sin nada visible que lo explicara.

   Se corrige por INSTANCIA, nunca tocando ModalComponent/DrawerComponent:
   esas clases las comparten quick-view, la busqueda y el modal de wishlist,
   que SI deben bloquear el scroll cuando el usuario los abre a proposito.
   isLockingNeeded es un getter de la clase; Object.defineProperty lo
   sombrea SOLO en la instancia de #CartDrawer. show()/hide() siguen
   corriendo con normalidad (siguen poniendo open/active, que la Enmienda
   9.2 ya neutraliza visualmente) pero saltan por completo los dos `if
   (this.isLockingNeeded)` de theme.js -- nunca agregan modal-showing ni
   modal-show, nunca los quitan, nunca tocan el contador compartido de
   candados.

   SEGURIDAD DE TIEMPO: show() SOLO es invocable despues de que theme.js
   ejecuto customElements.define('cart-drawer', CartDrawer) -- por eso, en
   la ventana de hidratacion de la Enmienda 9, el clic no llega a llamar
   show() en absoluto (cae a un POST nativo del formulario, medido en
   reports/cls-cabecera-20260821/FASE6-BLOQUE-C.md). Este archivo es
   <script defer>, en el MISMO lote de scripts diferidos que theme.js: se
   ejecutan pegados, sin hueco para que un clic real de usuario se cuele
   entre uno y otro. No hay ventana de carrera aqui.

   Con el interruptor apagado este archivo entero no se enlaza (ver
   layout/theme.liquid): el candado de scroll del cajon sigue funcionando
   exactamente como siempre. */
(function () {
  'use strict';
  var cajon = document.querySelector('cart-drawer#CartDrawer');
  if (!cajon) return;
  try {
    Object.defineProperty(cajon, 'isLockingNeeded', {
      configurable: true,
      get: function () { return false; },
    });
  } catch (e) {
    console.warn('[maha-aviso] no se pudo neutralizar isLockingNeeded de CartDrawer:', e);
  }
})();

(function () {
  'use strict';

  var MOVIL = '(max-width: 749px)';

  /* El nodo se re-resuelve siempre: Hyper reemplaza secciones enteras y
     guardar la referencia deja punteros muertos. */
  function nodo() { return document.getElementById('MahaAviso'); }
  function esMovil() { return window.matchMedia(MOVIL).matches; }

  var temporizador = null;
  var restanteAl = 0;      /* marca de tiempo en la que expira */
  var duracionActual = 0;

  function limpiarTemporizador() {
    if (temporizador) { clearTimeout(temporizador); temporizador = null; }
  }

  function ocultar() {
    var el = nodo();
    limpiarTemporizador();
    if (!el) return;
    el.classList.remove('is-visible', 'is-corriendo', 'is-pausado', 'is-arrastrando');
    el.style.transform = '';
    el.hidden = true;
  }

  function arrancarCuenta(el) {
    duracionActual = parseInt(el.getAttribute(esMovil() ? 'data-duracion-movil' : 'data-duracion-escritorio'), 10);
    if (!(duracionActual > 0)) duracionActual = esMovil() ? 3000 : 5000;
    el.style.setProperty('--maha-aviso-duracion', duracionActual + 'ms');
    el.classList.remove('is-pausado');
    /* Reiniciar la barra: quitar la clase, forzar un reflow y volver a
       ponerla, o la transicion no se reinicia al actualizar el aviso. */
    el.classList.remove('is-corriendo');
    void el.offsetWidth;
    el.classList.add('is-corriendo');
    restanteAl = Date.now() + duracionActual;
    limpiarTemporizador();
    temporizador = setTimeout(ocultar, duracionActual);
  }

  /* El contador se DETIENE con el raton encima o el foco dentro. En movil no
     aplica: alli se descarta deslizando. */
  function pausar() {
    var el = nodo();
    if (!el || esMovil() || !temporizador) return;
    limpiarTemporizador();
    var barra = el.querySelector('.maha-aviso__tiempo > i');
    if (barra) {
      var t = getComputedStyle(barra).transform;
      el.classList.add('is-pausado');
      barra.style.transform = t === 'none' ? '' : t;
    }
  }

  function reanudar() {
    var el = nodo();
    if (!el || esMovil() || el.hidden) return;
    var restante = Math.max(400, restanteAl - Date.now());
    var barra = el.querySelector('.maha-aviso__tiempo > i');
    if (barra) barra.style.transform = '';
    el.style.setProperty('--maha-aviso-duracion', restante + 'ms');
    el.classList.remove('is-pausado');
    restanteAl = Date.now() + restante;
    limpiarTemporizador();
    temporizador = setTimeout(ocultar, restante);
  }

  /* ENMIENDA 8, 2026-08-24: el "·" es del VALOR (piezas), no de la variante.
     Se declara con atributos que pone el JS -- nunca :empty, que un solo
     espacio ya lo hace falso -- y cuando NINGUNO de los dos lados tiene
     contenido, la linea completa se oculta sin dejar hueco. */
  function actualizarLineaDetalle(el) {
    var variante = el.querySelector('[data-aviso-variante]');
    var piezas = el.querySelector('[data-aviso-piezas]');
    var detalle = el.querySelector('.maha-aviso__detalle');
    if (!detalle) return;
    var hayVariante = !!(variante && !variante.hidden && variante.textContent);
    var hayPiezas = !!(piezas && piezas.hasAttribute('data-con-contenido'));
    detalle.hidden = !hayVariante && !hayPiezas;
  }

  function mostrar(datos) {
    var el = nodo();
    if (!el) return;
    datos = datos || {};

    var nombre = el.querySelector('[data-aviso-nombre]');
    var variante = el.querySelector('[data-aviso-variante]');
    var piezas = el.querySelector('[data-aviso-piezas]');
    var foto = el.querySelector('[data-aviso-foto]');

    if (nombre) nombre.textContent = datos.nombre || '';
    if (variante) {
      variante.textContent = datos.variante || '';
      /* [hidden], no :empty: es lo que lee el CSS del separador y lo que
         cuenta actualizarLineaDetalle() para decidir si hay "lado izquierdo". */
      variante.hidden = !datos.variante;
    }
    /* Se vacia a proposito: la cifra llega despues, en este mismo hueco
       (Enmienda 4 la rellena YA, en el clic; esto es el estado de partida
       mientras esa cifra no exista todavia). */
    if (piezas) {
      piezas.textContent = '';
      piezas.removeAttribute('data-con-contenido');
    }
    actualizarLineaDetalle(el);

    if (foto) {
      var quieroFoto = datos.foto && (!esMovil() || el.hasAttribute('data-miniatura-movil'));
      if (quieroFoto) { foto.src = datos.foto; foto.hidden = false; }
      else { foto.removeAttribute('src'); foto.hidden = true; }
    }

    el.hidden = false;
    void el.offsetWidth;
    el.classList.add('is-visible');
    arrancarCuenta(el);
  }

  /* ENMIENDA 3, 2026-08-24 -- correccion del servidor, sin reiniciar nada.
     product_title/variant_title/image llegan en la MISMA respuesta que ya
     trae las piezas -- no hay peticion extra. A diferencia de mostrar(), esto
     NO toca is-visible ni arrancarCuenta(): el aviso ya esta en pantalla y su
     barra de tiempo ya esta corriendo: reiniciarla aqui la haria "saltar" en
     el caso comun (donde no hay nada que corregir, ver el 'if' que llama a
     esto solo cuando algo difiere de verdad). */
  function corregir(datos) {
    var el = nodo();
    if (!el || el.hidden) return;
    datos = datos || {};

    var nombre = el.querySelector('[data-aviso-nombre]');
    var variante = el.querySelector('[data-aviso-variante]');
    var foto = el.querySelector('[data-aviso-foto]');

    if (nombre && datos.nombre) nombre.textContent = datos.nombre;
    if (variante && typeof datos.variante === 'string') {
      variante.textContent = datos.variante;
      variante.hidden = !datos.variante;
    }
    if (foto && datos.foto) {
      var quieroFoto = !esMovil() || el.hasAttribute('data-miniatura-movil');
      if (quieroFoto) { foto.src = datos.foto; foto.hidden = false; }
    }
    actualizarLineaDetalle(el);
  }

  function ponerPiezas(n) {
    var el = nodo();
    if (!el || el.hidden) return;
    var piezas = el.querySelector('[data-aviso-piezas]');
    if (!piezas) return;
    var cantidad = parseInt(n, 10);
    if (!(cantidad > 0)) {
      piezas.textContent = '';
      piezas.removeAttribute('data-con-contenido');
      actualizarLineaDetalle(el);
      return;
    }
    /* Cuatro formas, todas en locales: singular/plural x escritorio/movil.
       En movil el texto lleva "agregadas" porque ahi el nombre ocupa el sitio
       del titulo "Agregado al carrito" y sin esa palabra la barra no dice que
       ha pasado. Nada de literales aqui. */
    var T = window.MahaAvisoTextos || {};
    var movil = esMovil();
    var plantilla = cantidad === 1
      ? (movil ? T.piezaAgregada : T.pieza)
      : (movil ? T.piezasAgregadas : T.piezas);
    if (!plantilla) plantilla = '{{ n }}';
    piezas.textContent = plantilla.replace('{{ n }}', cantidad.toLocaleString('en-US'));
    /* data-con-contenido, no :empty: el atributo es lo unico que decide el
       "·" (CSS) y el "hay piezas" (actualizarLineaDetalle). */
    piezas.setAttribute('data-con-contenido', '1');
    actualizarLineaDetalle(el);
  }

  /* ---------------- gestos y eventos ----------------
     Todo delegado en el documento: el nodo puede ser reemplazado. */
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-aviso-cerrar]')) { ev.preventDefault(); ocultar(); }
  });

  document.addEventListener('mouseover', function (ev) {
    if (ev.target && ev.target.closest && ev.target.closest('#MahaAviso')) pausar();
  });
  document.addEventListener('mouseout', function (ev) {
    if (ev.target && ev.target.closest && ev.target.closest('#MahaAviso')) {
      if (!ev.relatedTarget || !ev.relatedTarget.closest || !ev.relatedTarget.closest('#MahaAviso')) reanudar();
    }
  });
  document.addEventListener('focusin', function (ev) {
    if (ev.target && ev.target.closest && ev.target.closest('#MahaAviso')) pausar();
  });
  document.addEventListener('focusout', function (ev) {
    var el = nodo();
    if (!el) return;
    setTimeout(function () { if (!el.contains(document.activeElement)) reanudar(); }, 0);
  });

  /* En movil se descarta DESLIZANDO hacia abajo. Solo se captura el gesto
     vertical hacia abajo; cualquier otro se deja pasar para no secuestrar el
     scroll de la pagina. */
  (function () {
    var y0 = null, arrastrando = false;
    document.addEventListener('touchstart', function (ev) {
      var el = nodo();
      if (!el || el.hidden || !esMovil()) return;
      if (!ev.target.closest || !ev.target.closest('#MahaAviso')) return;
      y0 = ev.touches[0].clientY;
      arrastrando = false;
    }, { passive: true });

    document.addEventListener('touchmove', function (ev) {
      var el = nodo();
      if (y0 === null || !el || el.hidden) return;
      var dy = ev.touches[0].clientY - y0;
      if (dy <= 0) return;                 /* hacia arriba: no es descartar */
      if (!arrastrando && dy < 6) return;  /* umbral: evita falsos positivos */
      arrastrando = true;
      el.classList.add('is-arrastrando');
      el.style.transform = 'translateY(' + dy + 'px)';
      el.style.opacity = String(Math.max(0, 1 - dy / 120));
    }, { passive: true });

    document.addEventListener('touchend', function () {
      var el = nodo();
      if (y0 === null) return;
      y0 = null;
      if (!el) return;
      var m = /translateY\((\d+(?:\.\d+)?)px\)/.exec(el.style.transform || '');
      var dy = m ? parseFloat(m[1]) : 0;
      el.classList.remove('is-arrastrando');
      el.style.opacity = '';
      if (arrastrando && dy > 40) ocultar();
      else el.style.transform = '';
      arrastrando = false;
    }, { passive: true });
  })();

  window.MahaAviso = { mostrar: mostrar, piezas: ponerPiezas, cancelar: ocultar, corregir: corregir };
})();
